<template>
  <el-dialog
      :title="$t('text.cardSort')"
      :visible="show"
      width="400px"
      @close="closeDialog"
      :modal-append-to-body="false"
  >
    <div class="card-list-container">
      <draggable v-model="cards" handle=".handle" animation="200">
        <transition-group>
          <div
              v-for="(card, index) in cards"
              :key="card.groupId"
              class="card-item"
          >
            <span class="handle">⋮⋮</span>
            {{ card.groupName }}
          </div>
        </transition-group>
      </draggable>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button :disabled="loading" @click="closeDialog">{{ $t('text.cancel') }}</el-button>
      <el-button type="primary" :loading="loading" @click="confirm">{{ $t('text.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'CardSortDialog',
  components: {draggable},
  props: {
    show: Boolean,
    initialCards: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      cards: [],
      loading: false
    }
  },
  created() {
    this.cards = this.initialCards.map((card, index) => ({
      groupId: card.groupId,
      priority: card.priority,
      groupName: card.groupName,
    }));
  },
  methods: {
    closeDialog() {
      this.$emit('update:show', false);
    },
    confirm() {
      this.loading = true
      const sortCardGroupList = this.cards.map((card, index) => ({
        groupId: card.groupId,
        priority: index
      }))
      this.axios.put("/card-group/sortCardGroup", sortCardGroupList, {
        headers: {'Content-Type': 'application/json'},
        transformRequest: [(data) => JSON.stringify(data)],
      }).then(res => {
        if (res.code === 200) {

          this.show = false;
          this.$message.success(this.$t('message.editAgentSuccess'));

          this.$emit('refresh-card-group-list');
          this.cancel();
          this.loading = false;
        } else {
          this.$notify.error({
            title: this.$t('text.operationFailed'),
            message: res.msg,
          });
        }
      })
      this.loading = false;
    }
  }
}
</script>

<style scoped>
.card-list-container {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ebeef5;
  padding: 10px;
  margin-bottom: 10px;
}

.card-item {
  display: flex;
  align-items: center;
  padding: 8px;
  border: 1px solid #dcdfe6;
  background: #f5f7fa;
  margin-bottom: 6px;
  border-radius: 4px;
}

.handle {
  cursor: grab;
  margin-right: 10px;
}

.dialogModelStyle .el-dialog {
  z-index: 500 !important;
  background: red;
}

</style>
